import { FC } from 'react';
import { FormLink } from '../components/shared/FormLink';
import { UrlsFront } from '../constants/urls';

type Props = {
  show?: boolean;
};

/**Componente que contiene un enlace al formulario de login. */
export const AuthLink: FC<Props> = ({ show }) => {
  return <FormLink title="Ingreso" url={UrlsFront.LogIn} show={show} />;
};
